import { VideoCameraOutlined, FileSearchOutlined, FileDoneOutlined } from '@ant-design/icons';
import { OPERATIONS } from 'constants';

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const testingResults = {
  id: 'testing_results',
  title: 'Testing Results',
  type: 'group',
  exclude: true,
  children: [
    {
      id: 'video_question_test_results',
      title: 'Video Question Results',
      type: 'item',
      url: '/testing-results/video-question-results',
      icon: VideoCameraOutlined,
      altId: 'video_questions',
      operations: [OPERATIONS.VIEW]
    },
    {
      id: 'resume_screen_test_results',
      title: 'Resume Screen Results',
      type: 'item',
      url: '/testing-results/resume-screen-results',
      icon: FileSearchOutlined,
      altId: 'resume_profiles',
      operations: [OPERATIONS.VIEW]
    },
    {
      id: 'typing_assessment_test_results',
      title: 'Typing Test Results',
      type: 'item',
      url: '/testing-results/typing-test-results',
      icon: FileDoneOutlined,
      altId: 'typing_tests',
      operations: [OPERATIONS.VIEW]
    }
  ]
};

export default testingResults;
